import {array, number, object, string} from 'yup';

import {paginationV8nSchema} from '@shared/api';

export const stakeV8nSchema = object().shape({
  id: string().required(),
  user_id: string().required(),
  group_id: string().required(),
  event_id: string().required(),
  event_slug: string().required(),
  event_status: string().required(),
  real: number().integer().required(),
  promo: number().integer().required(),
  local_amount: number().integer().required(),
  currency: string().required(),
  rate: string().required(),
  status: string().required(),
  payout_real: number().integer().nullable().optional(),
  payout_promo: number().integer().nullable().optional(),
  created_at: string().required(),
});

export const v8nSchemaOfGetStakesResponse = paginationV8nSchema.shape({
  array: array().of(stakeV8nSchema).required(),
});
